/**
 * Infinity Container Color & Material Data
 * Extracted from Velocity Sports Equipment designer (design.velocityrigs.com)
 *
 * Drives the color swatches in the configurator UI and the 3D viewer material updates.
 * Available globally as window.InfinityColors
 */

const InfinityColors = {

  /* ─── Cordura Fabric Colors ─────────────────────────────────────────────── */
  cordura: {
    Turquoise: { hex: '#07492e', fill: 0x07492e },
    Purple: { hex: '#4f1061', fill: 0x4f1061 },
    Amethyst: { hex: '#512b63', fill: 0x512b63 },
    Burgundy: { hex: '#5c0a25', fill: 0x5c0a25 },
    NeonPink: { hex: '#ff2970', fill: 0xff2970 },
    NavyBlue: { hex: '#030f29', fill: 0x030f29 },
    RoyalBlue: { hex: '#193063', fill: 0x193063 },
    NeonBlue: { hex: '#188c94', fill: 0x188c94 },
    ForestGreen: { hex: '#2c470b', fill: 0x2c470b },
    KellyGreen: { hex: '#2e7010', fill: 0x2e7010 },
    Jade: { hex: '#1d7e58', fill: 0x1d7e58 },
    NeonGreen: { hex: '#8fe83c', fill: 0x8fe83c },
    NeonYellow: { hex: '#f3f315', fill: 0xf3f315 },
    Yellow: { hex: '#f2df11', fill: 0xf2df11 },
    Gold: { hex: '#f2a51f', fill: 0xf2a51f },
    NeonOrange: { hex: '#f02f22', fill: 0xf02f22 },
    Orange: { hex: '#ff5900', fill: 0xff5900 },
    Red: { hex: '#b31010', fill: 0xb31010 },
    Black: { hex: '#000000', fill: 0x000000 },
    Charcoal: { hex: '#635a4e', fill: 0x635a4e },
    Silver: { hex: '#9c9983', fill: 0x9c9983 },
    White: { hex: '#ffffff', fill: 0xffffff },
    Brown: { hex: '#3b1f0b', fill: 0x3b1f0b },
    OliveDrab: { hex: '#4f4906', fill: 0x4f4906 },
    Coyote: { hex: '#8c7446', fill: 0x8c7446 },
    Kryptek: { hex: '#8a8a6e', fill: 0x8a8a6e, camo: true, texture: 'infinity-material-Cordura_Kryptek.jpg' },
    DesertDigital: { hex: '#c2b59b', fill: 0xc2b59b, camo: true, texture: 'infinity-material-Cordura_DesertDigital.jpg' },
    Multicam: { hex: '#6b5b3a', fill: 0x6b5b3a, camo: true, texture: 'infinity-material-Cordura_Multicam.jpg' },
    MulticamBlack: { hex: '#1a1a1a', fill: 0x1a1a1a, camo: true, texture: 'infinity-material-Cordura_MulticamBlack.jpg' },
    Universal: { hex: '#4a5a3a', fill: 0x4a5a3a, camo: true, texture: 'infinity-material-Cordura_Universal.jpg' },
    Woodland: { hex: '#3a4a2a', fill: 0x3a4a2a, camo: true, texture: 'infinity-material-Cordura_Woodland.jpg' },
    WoodlandDigital: { hex: '#5a6a4a', fill: 0x5a6a4a, camo: true, texture: 'infinity-material-Cordura_WoodlandDigital.jpg' }
  },

  /* ─── Binding Tape Colors (Bindingtape palette from Velocity) ────────────── */
  bindingTape: {
    Purple: { hex: '#4f1061', fill: 0x4f1061 },
    Burgundy: { hex: '#5c0a25', fill: 0x5c0a25 },
    Magenta: { hex: '#a80f47', fill: 0xa80f47 },
    NeonPink: { hex: '#ff2970', fill: 0xff2970 },
    NavyBlue: { hex: '#030f29', fill: 0x030f29 },
    RoyalBlue: { hex: '#122382', fill: 0x122382 },
    NeonBlue: { hex: '#188c94', fill: 0x188c94 },
    KellyGreen: { hex: '#8b9c2a', fill: 0x8b9c2a },
    NeonGreen: { hex: '#8dbd13', fill: 0x8dbd13 },
    Yellow: { hex: '#f2e446', fill: 0xf2e446 },
    Gold: { hex: '#f2a51f', fill: 0xf2a51f },
    NeonOrange: { hex: '#f02f22', fill: 0xf02f22 },
    Orange: { hex: '#ff5900', fill: 0xff5900 },
    Red: { hex: '#b31010', fill: 0xb31010 },
    Black: { hex: '#000000', fill: 0x000000 },
    Charcoal: { hex: '#4a443d', fill: 0x4a443d },
    Silver: { hex: '#c4c09d', fill: 0xc4c09d },
    OliveDrab: { hex: '#545019', fill: 0x545019 },
    Tan: { hex: '#cfa770', fill: 0xcfa770 }
  },

  /* ─── Binding Tape Stitching Colors ─────────────────────────────────────── */
  bindingTapeStitching: {
    None: { hex: 'transparent', fill: null },
    Black: { hex: '#000000', fill: 0x000000 },
    Burgundy: { hex: '#5c0a25', fill: 0x5c0a25 },
    Charcoal: { hex: '#635a4e', fill: 0x635a4e },
    ForestGreen: { hex: '#2c470b', fill: 0x2c470b },
    Gold: { hex: '#f2a51f', fill: 0xf2a51f },
    Turquoise: { hex: '#07492e', fill: 0x07492e },
    NeonBlue: { hex: '#188c94', fill: 0x188c94 },
    NeonGreen: { hex: '#8fe83c', fill: 0x8fe83c },
    NeonOrange: { hex: '#f02f22', fill: 0xf02f22 },
    NeonPink: { hex: '#ff2970', fill: 0xff2970 },
    OliveDrab: { hex: '#4f4906', fill: 0x4f4906 },
    Orange: { hex: '#ff5900', fill: 0xff5900 },
    Purple: { hex: '#4f1061', fill: 0x4f1061 },
    Red: { hex: '#b31010', fill: 0xb31010 },
    RoyalBlue: { hex: '#193063', fill: 0x193063 },
    Tan: { hex: '#c2a875', fill: 0xc2a875 },
    White: { hex: '#ffffff', fill: 0xffffff },
    Yellow: { hex: '#f2df11', fill: 0xf2df11 }
  },

  /* ─── Pinstripe Colors (dedicated Pinstripes palette from Velocity) ────── */
  pinstripes: {
    Purple: { hex: '#4f1061', fill: 0x4f1061 },
    Burgundy: { hex: '#5c0a25', fill: 0x5c0a25 },
    Magenta: { hex: '#a80f47', fill: 0xa80f47 },
    NeonPink: { hex: '#ff2970', fill: 0xff2970 },
    NavyBlue: { hex: '#030f29', fill: 0x030f29 },
    RoyalBlue: { hex: '#122382', fill: 0x122382 },
    NeonBlue: { hex: '#188c94', fill: 0x188c94 },
    KellyGreen: { hex: '#8b9c2a', fill: 0x8b9c2a },
    NeonGreen: { hex: '#8dbd13', fill: 0x8dbd13 },
    Yellow: { hex: '#f2e446', fill: 0xf2e446 },
    Gold: { hex: '#f2a51f', fill: 0xf2a51f },
    NeonOrange: { hex: '#f02f22', fill: 0xf02f22 },
    Orange: { hex: '#ff5900', fill: 0xff5900 },
    Red: { hex: '#b31010', fill: 0xb31010 },
    Black: { hex: '#000000', fill: 0x000000 },
    Charcoal: { hex: '#4a443d', fill: 0x4a443d },
    Silver: { hex: '#c4c09d', fill: 0xc4c09d },
    White: { hex: '#ffffff', fill: 0xffffff },
    OliveDrab: { hex: '#545019', fill: 0x545019 },
    Tan: { hex: '#cfa770', fill: 0xcfa770 },
    None: { hex: 'transparent', fill: null }
  },

  /* ─── Type 17 Webbing Colors (Risers & Webbing from Velocity) ──────────── */
  type17: {
    Purple: { hex: '#4f1061', fill: 0x4f1061 },
    NavyBlue: { hex: '#030f29', fill: 0x030f29 },
    RoyalBlue: { hex: '#384f80', fill: 0x384f80 },
    Yellow: { hex: '#f2df11', fill: 0xf2df11 },
    Gold: { hex: '#f2a51f', fill: 0xf2a51f },
    Orange: { hex: '#ff5900', fill: 0xff5900 },
    Red: { hex: '#b31010', fill: 0xb31010 },
    Black: { hex: '#000000', fill: 0x000000 },
    Charcoal: { hex: '#635a4e', fill: 0x635a4e },
    Silver: { hex: '#9c9983', fill: 0x9c9983 },
    White: { hex: '#ffffff', fill: 0xffffff },
    OliveDrab: { hex: '#4f4906', fill: 0x4f4906 }
  },

  /* ─── Pilot Chute Colors ────────────────────────────────────────────────── */
  pilotChuteColors: {
    Black: { hex: '#000000', fill: 0x000000 },
    Purple: { hex: '#4f1061', fill: 0x4f1061 },
    Jade: { hex: '#1d7e58', fill: 0x1d7e58 },
    KellyGreen: { hex: '#2e7010', fill: 0x2e7010 },
    Magenta: { hex: '#c2185b', fill: 0xc2185b },
    NeonPink: { hex: '#ff2970', fill: 0xff2970 },
    NeonOrange: { hex: '#f02f22', fill: 0xf02f22 },
    Red: { hex: '#b31010', fill: 0xb31010 },
    RoyalBlue: { hex: '#193063', fill: 0x193063 },
    Silver: { hex: '#9c9983', fill: 0x9c9983 },
    White: { hex: '#ffffff', fill: 0xffffff },
    NeonYellow: { hex: '#f3f315', fill: 0xf3f315 },
    Navy: { hex: '#030f29', fill: 0x030f29 },
    NeonBlue: { hex: '#188c94', fill: 0x188c94 }
  },

  /* ─── Embroidery Thread Colors ───────────────────────────────────────────── */
  embroidery: {
    None: { hex: 'transparent', fill: null },
    Black: { hex: '#000000', fill: 0x000000 },
    White: { hex: '#ffffff', fill: 0xffffff },
    Silver: { hex: '#9c9983', fill: 0x9c9983 },
    Red: { hex: '#b31010', fill: 0xb31010 },
    Burgundy: { hex: '#5c0a25', fill: 0x5c0a25 },
    NeonPink: { hex: '#ff2970', fill: 0xff2970 },
    Fuchsia: { hex: '#a80f47', fill: 0xa80f47 },
    Magenta: { hex: '#821943', fill: 0x821943 },
    Purple: { hex: '#4f1061', fill: 0x4f1061 },
    Amethyst: { hex: '#512b63', fill: 0x512b63 },
    NavyBlue: { hex: '#030f29', fill: 0x030f29 },
    RoyalBlue: { hex: '#193063', fill: 0x193063 },
    NeonBlue: { hex: '#188c94', fill: 0x188c94 },
    Jade: { hex: '#0a6943', fill: 0x0a6943 },
    ForestGreen: { hex: '#2c470b', fill: 0x2c470b },
    KellyGreen: { hex: '#2e7010', fill: 0x2e7010 },
    NeonGreen: { hex: '#8fe83c', fill: 0x8fe83c },
    OliveDrab: { hex: '#4f4906', fill: 0x4f4906 },
    NeonYellow: { hex: '#f3f315', fill: 0xf3f315 },
    Yellow: { hex: '#f2df11', fill: 0xf2df11 },
    Gold: { hex: '#f2a51f', fill: 0xf2a51f },
    Orange: { hex: '#ff5900', fill: 0xff5900 },
    NeonOrange: { hex: '#f02f22', fill: 0xf02f22 },
    Brown: { hex: '#3b1f0b', fill: 0x3b1f0b },
    Tan: { hex: '#cfa770', fill: 0xcfa770 },
    Charcoal: { hex: '#635a4e', fill: 0x635a4e }
  },

  /* ─── Embroidery Zones ─────────────────────────────────────────────────── */
  embroideryZones: [
    {
      key: '1flap', label: '#1 Flap',
      fields: [
        { key: 'embroidery_1flap_symbol_fill', label: 'Symbol Fill' },
        { key: 'embroidery_1flap_symbol_out', label: 'Symbol Outline' }
      ]
    },
    {
      key: 'ring_cover', label: 'Left Ring Cover',
      fields: [
        { key: 'embroidery_ring_cover_text_fill', label: 'Text Fill' },
        { key: 'embroidery_ring_cover_text_out', label: 'Text Outline' },
        { key: 'embroidery_ring_cover_symbol_fill', label: 'Symbol Fill' },
        { key: 'embroidery_ring_cover_symbol_out', label: 'Symbol Outline' }
      ]
    },
    {
      key: 'sidebody', label: 'Sidebodies',
      fields: [
        { key: 'embroidery_sidebody_text_fill', label: 'Text Fill' },
        { key: 'embroidery_sidebody_text_out', label: 'Text Outline' },
        { key: 'embroidery_sidebody_symbol_fill', label: 'Symbol Fill' },
        { key: 'embroidery_sidebody_symbol_out', label: 'Symbol Outline' }
      ]
    },
    {
      key: 'riser_cover', label: 'Riser Covers',
      fields: [
        { key: 'embroidery_riser_cover_text_fill', label: 'Text Fill' },
        { key: 'embroidery_riser_cover_text_out', label: 'Text Outline' },
        { key: 'embroidery_riser_cover_symbol_fill', label: 'Symbol Fill' },
        { key: 'embroidery_riser_cover_symbol_out', label: 'Symbol Outline' }
      ]
    }
  ],

  /* ─── Display Name Mapping (camelCase → "Display Name") ─────────────────── */
  displayNames: {
    Turquoise: 'Turquoise',
    Purple: 'Purple',
    Amethyst: 'Amethyst',
    Burgundy: 'Burgundy',
    NeonPink: 'Neon Pink',
    NavyBlue: 'Navy Blue',
    RoyalBlue: 'Royal Blue',
    NeonBlue: 'Neon Blue',
    ForestGreen: 'Forest Green',
    KellyGreen: 'Kelly Green',
    Jade: 'Jade',
    NeonGreen: 'Neon Green',
    NeonYellow: 'Neon Yellow',
    Yellow: 'Yellow',
    Gold: 'Gold',
    NeonOrange: 'Neon Orange',
    Orange: 'Orange',
    Red: 'Red',
    Black: 'Black',
    Charcoal: 'Charcoal',
    Silver: 'Silver',
    White: 'White',
    Brown: 'Brown',
    OliveDrab: 'Olive Drab',
    Coyote: 'Coyote',
    Kryptek: 'Kryptek',
    DesertDigital: 'Desert Digital',
    Multicam: 'Multicam',
    MulticamBlack: 'Multicam Black',
    Universal: 'Universal',
    Woodland: 'Woodland',
    WoodlandDigital: 'Woodland Digital',
    Magenta: 'Magenta',
    Fuchsia: 'Fuchsia',
    Navy: 'Navy',
    Tan: 'Tan',
    None: 'None'
  },

  /* ─── Panel Zones (all colorable regions) ───────────────────────────────── */
  panelZones: [
    { key: 'container_panel_1_color', label: 'Panel 1', group: 'panels', palette: 'cordura' },
    { key: 'container_panel_2_color', label: 'Panel 2', group: 'panels', palette: 'cordura' },
    { key: 'container_panel_3_color', label: 'Panel 3', group: 'panels', palette: 'cordura' },
    { key: 'container_panel_4_color', label: 'Panel 4', group: 'panels', palette: 'cordura' },
    { key: 'container_panel_5_color', label: 'Panel 5', group: 'panels', palette: 'cordura' },
    { key: 'container_centerflap_a_color', label: 'Center Panel A', group: 'centerFlaps', palette: 'cordura' },
    { key: 'container_centerflap_b_color', label: 'Center Panel B', group: 'centerFlaps', palette: 'cordura' },
    { key: 'container_centerflap_c_color', label: 'Center Panel C', group: 'centerFlaps', palette: 'cordura' },
    { key: 'container_centerflap_d_color', label: 'Center Panel D', group: 'centerFlaps', palette: 'cordura' },
    { key: 'container_centerflap_e_color', label: 'Center Panel E', group: 'centerFlaps', palette: 'cordura' },
    { key: 'container_pinstripe_ab_color', label: 'Pinstripe A-B', group: 'pinstripes', palette: 'pinstripes' },
    { key: 'container_pinstripe_bc_color', label: 'Pinstripe B-C', group: 'pinstripes', palette: 'pinstripes' },
    { key: 'container_pinstripe_cd_color', label: 'Pinstripe C-D', group: 'pinstripes', palette: 'pinstripes' },
    { key: 'container_pinstripe_de_color', label: 'Pinstripe D-E', group: 'pinstripes', palette: 'pinstripes' },
    { key: 'container_backpad_color', label: 'Backpad', group: 'extras', palette: 'cordura' },
    { key: 'container_mudflap_color', label: 'Ring Cover', group: 'extras', palette: 'cordura' },
    { key: 'container_bindingtape_color', label: 'Binding Tape', group: 'extras', palette: 'bindingTape' },
    { key: 'container_legpads_in_color', label: 'Legpads Inside', group: 'extras', palette: 'cordura' },
    { key: 'container_legpads_out_color', label: 'Legpads Outside', group: 'extras', palette: 'cordura' },
    { key: 'container_cutaway_color', label: 'Cutaway Handle', group: 'extras', palette: 'cordura' },
    { key: 'container_risers_color', label: 'Container Risers', group: 'extras', palette: 'type17' },
    { key: 'webbing_color', label: 'Webbing', group: 'extras', palette: 'type17' },
    { key: 'container_reserve_color', label: 'Reserve', group: 'extras', palette: 'cordura' }
  ],

  /* ─── Default Configuration (from Velocity designer) ─────────────────────── */
  defaultConfiguration: {
    container_panel_1_color: 'Red',
    container_panel_2_color: 'Silver',
    container_panel_3_color: 'Black',
    container_panel_4_color: 'Black',
    container_panel_5_color: 'Red',
    container_centerflap_a_color: 'Red',
    container_centerflap_b_color: 'White',
    container_centerflap_c_color: 'Black',
    container_centerflap_d_color: 'White',
    container_centerflap_e_color: 'Red',
    container_pinstripe_ab_color: 'None',
    container_pinstripe_bc_color: 'None',
    container_pinstripe_cd_color: 'None',
    container_pinstripe_de_color: 'None',
    container_backpad_color: 'Black',
    container_bindingtape_color: 'Black',
    container_legpads_in_color: 'Black',
    container_legpads_out_color: 'Black',
    container_cutaway_color: 'Red',
    container_mudflap_color: 'Red',
    container_risers_color: 'Red',
    container_reserve_color: 'Red',
    binding_tape_stitching_color: 'None',
    pilot_chute_color: 'Black',
    design_party_stripe_color: 'White',
    design_party_pinstripe_1_color: 'None',
    design_party_pinstripe_2_color: 'None',
    design_xout_color: 'White'
  },

  /* ─── Upgrade Products (Shopify product handles for cart integration) ───── */
  upgradeProducts: {
    partyStripe: { handle: 'infinity-upgrade-party-stripe', label: 'Party Stripe Pattern', price: 199 },
    xout: { handle: 'infinity-upgrade-xout', label: 'X-Out Pattern', price: 322 },
    magRiser: { handle: 'infinity-upgrade-mag-riser', label: 'Magnetic Riser Cover', price: 293 },
    chestRings: { handle: 'infinity-upgrade-chest-rings', label: 'Chest Rings', price: 316 },
    blackHardware: { handle: 'infinity-upgrade-black-hardware', label: 'Black Stainless Steel', price: 88 },
    doubleLegstraps: { handle: 'infinity-upgrade-double-legstraps', label: 'Double-Wide Leg Straps', price: 59 },
    bellyBand: { handle: 'infinity-upgrade-belly-band', label: 'Belly Band', price: 176 },
    jackBellyBand: { handle: 'infinity-upgrade-jack-belly-band', label: 'Jack Belly Band w/ Zipper', price: 293 },
    extendedBridle: { handle: 'infinity-upgrade-extended-bridle', label: 'Extended Bridle 9\'', price: 23 },
    swoopLoops: { handle: 'infinity-upgrade-swoop-loops', label: 'Swoop Loops', price: 53 },
    compRisers: { handle: 'infinity-upgrade-comp-risers', label: 'Comp Risers', price: 100 },
    semiStowless: { handle: 'infinity-upgrade-semi-stowless', label: 'Semi-Stowless Bag', price: 64 },
    aluminumHookknife: { handle: 'infinity-upgrade-aluminum-hookknife', label: 'Black Aluminum Hook Knife', price: 59 },
    mudflapSnap: { handle: 'infinity-upgrade-mudflap-snap', label: 'Right Mudflap Snap', price: 29 },
    designServices: { handle: 'infinity-upgrade-design-services', label: 'Design Services & Mock-Up', price: 468 }
  },

  /* ─── Helper Methods ────────────────────────────────────────────────────── */

  /**
   * Get display name for a color key
   * @param {string} colorKey — camelCase color name
   * @returns {string} — Human-readable display name
   */
  getDisplayName(colorKey) {
    return this.displayNames[colorKey] || colorKey;
  },

  /**
   * Get color data from any palette by key
   * @param {string} palette — palette name (e.g. 'cordura', 'bindingTape', 'type17')
   * @param {string} colorKey — color name
   * @returns {object|null} — Color data object or null
   */
  getColor(palette, colorKey) {
    return this[palette] ? this[palette][colorKey] || null : null;
  },

  /**
   * Get the palette name for a given zone key
   * @param {string} zoneKey — zone config key
   * @returns {string} — palette name (defaults to 'cordura')
   */
  getZonePalette(zoneKey) {
    const zone = this.panelZones.find(z => z.key === zoneKey);
    return zone ? zone.palette : 'cordura';
  },

  /**
   * Check if a color is a camo pattern
   * @param {string} colorKey — color name
   * @returns {boolean}
   */
  isCamo(colorKey) {
    const color = this.cordura[colorKey];
    return color ? !!color.camo : false;
  },

  /**
   * Get all colors for a given palette as an array of {key, ...data}
   * @param {string} palette — palette name
   * @returns {Array}
   */
  getPaletteArray(palette) {
    const data = this[palette];
    if (!data) return [];
    return Object.entries(data).map(([key, value]) => ({
      key,
      displayName: this.getDisplayName(key),
      ...value
    }));
  },

  /**
   * Get panel zones filtered by group
   * @param {string} group — 'panels', 'centerFlaps', 'pinstripes', or 'extras'
   * @returns {Array}
   */
  getZonesByGroup(group) {
    return this.panelZones.filter(zone => zone.group === group);
  }
};

/* ─── Expose globally ─────────────────────────────────────────────────────── */
window.InfinityColors = InfinityColors;
